module.exports = "/images/d0543299c90307a621c2081db79ff94c.png";